// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--2VT22","excerpt":"card-module--excerpt--2F0Au","tag":"card-module--tag--1nett","title":"card-module--title--PbUl-"};